const countriesStateAcronymToStateName: Record<
  string,
  Record<string, string>
> = {
  brasil: {
    'BR-AC': 'Acre',
    'BR-AL': 'Alagoas',
    'BR-AP': 'Amapá',
    'BR-AM': 'Amazonas',
    'BR-BA': 'Bahia',
    'BR-CE': 'Ceará',
    'BR-DF': 'Distrito Federal',
    'BR-ES': 'Espírito Santo',
    'BR-GO': 'Goiás',
    'BR-MA': 'Maranhão',
    'BR-MT': 'Mato Grosso',
    'BR-MS': 'Mato Grosso do Sul',
    'BR-MG': 'Minas Gerais',
    'BR-PA': 'Pará',
    'BR-PB': 'Paraíba',
    'BR-PR': 'Paraná',
    'BR-PE': 'Pernambuco',
    'BR-PI': 'Piauí',
    'BR-RJ': 'Rio de Janeiro',
    'BR-RN': 'Rio Grande do Norte',
    'BR-RS': 'Rio Grande do Sul',
    'BR-RO': 'Rondônia',
    'BR-RR': 'Roraima',
    'BR-SC': 'Santa Catarina',
    'BR-SP': 'São Paulo',
    'BR-SE': 'Sergipe',
    'BR-TO': 'Tocantins'
  },
  chile: {
    'CL-AP': 'Arica e Parinacota',
    'CL-TA': 'Tarapacá',
    'CL-AN': 'Antofagasta',
    'CL-AT': 'Atacama',
    'CL-CO': 'Coquimbo',
    'CL-VS': 'Valparaíso',
    'CL-ST': 'Santiago',
    'CL-LI': "O'Higgins",
    'CL-ML': 'Maule',
    'CL-NB': 'Ñuble',
    'CL-BI': 'Biobío',
    'CL-AR': 'Araucanía',
    'CL-LR': 'Los Ríos',
    'CL-LL': 'Los Lagos',
    'CL-AI': 'Aysén',
    'CL-MA': 'Magallanes'
  }
}

export default countriesStateAcronymToStateName
